export default "__VITE_ASSET__jOX310KK__"